export { PrivacyPolicy } from './PrivacyPolicy';
